import BaseItem, { Rarity } from './base_item';

export default class O2Tank extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "o2_tanks.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15;}
    static get height() { return 8;}

    static get mass() { return 2;}
    static get rarity() { return Rarity.COMMON; }
    static get electronic() { return false; }


    static get type() { return 'o2tank'}
    static get label() { return 'Oxygen tank'}
    static get description() { return `Rule 1. Never say no to oxygen tanks.`}
}


// WEBPACK FOOTER //
// ./src/objects/items/o2tank.js